// i18n.js
import i18next from "i18next";
import { createI18nStore } from "svelte-i18next";
// translations
import en from "./en.json";
import es from "./es.json";
import zh from "./zh.json";
import fr from "./fr.json";
import pt from "./pt.json";

i18next.init({
 lng: 'en',
 fallbackLng: 'en',
 resources: {
    en: { translation: { ...en } },
    es: { translation: { ...es } },
    zh: { translation: { ...zh } },
    fr: { translation: { ...fr } },
    pt: { translation: { ...pt } },
  },
  interpolation: {
    // not needed for svelte as it escapes by default
    escapeValue: false,
  }
});

// export default () => createI18nStore(i18next);
const i18n = createI18nStore(i18next);
export default i18n;
